import Layout from "components/layout/Layout";
// import Pricing1 from "../components/layout/pricing/Pricing1";

const Pricing = () => {
  return (
    <Layout
      headerStyle={1}
      footerStyle={1}
      breadcrumbTitle={
        <>
          {" "}
            Pricing <span>Plans</span>
        </>
      }
    >
        <div>
            <section className="job-details-area pb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p style={{ textAlign: "center", marginBottom: "0px" }}>Our pricing plans are still under development.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Layout>
  );
};
export default Pricing;
